module.exports = __webpack_public_path__ + "img/play_white.efb6909c.png";